import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useUpsertDocumentLabels } from 'src/hooks/documents-labels/upsert-documents-labels.hook';
import { useGetDocumentLabelsByCompany } from 'src/hooks/documents-labels/get-documents-labels.hook';
import { useDeleteDocumentLabelById } from 'src/hooks/documents-labels/delete-document-label-by-id.hook';
import { CommonPage } from 'src/pages/settings/components/company-settings-pages/components/common-page';

const DocumentsLabels = () => {
  const currentCompanyId = useGetCurrentCompanyId();
  const { documentsLabels } = useGetDocumentLabelsByCompany(currentCompanyId);

  const deleteDocumentLabelById = useDeleteDocumentLabelById();
  const upsertDocumentLabels = useUpsertDocumentLabels();

  const onFinish = (values: any) => {
    const payload = values?.labels ? values.labels : [values];

    if (payload.some((item: any) => !item.name)) return;

    upsertDocumentLabels({
      variables: {
        companyId: currentCompanyId,
        payload: payload.map(({ documentTemplates, ...restDoc }: any) => restDoc),
      },
    });
  };

  const onDelete = (values: any) => {
    deleteDocumentLabelById({ variables: { documentLabelId: values._id } });
  };

  return (
    <CommonPage
      pageType="documentsLabels"
      onFinish={onFinish}
      onDelete={onDelete}
      data={documentsLabels}
    />
  );
};

export default DocumentsLabels;
